import { useState, useCallback, type ReactNode } from 'react';
import { PageConfigContext } from './page-config-context';
import type { PageConfig } from './page-config-context';

export function PageConfigProvider({ children }: { children: ReactNode }) {
  const [config, setConfigState] = useState<PageConfig | null>(null);

  const setConfig = useCallback((next: PageConfig) => {
    setConfigState(next);
  }, []);

  return (
    <PageConfigContext.Provider value={{ config, setConfig }}>
      {children}
    </PageConfigContext.Provider>
  );
}
